import React, { PureComponent } from "react";
import PropTypes from "prop-types";
import { cssMainSelector } from "../lib/cssSelectors";
import styled from "styled-components";
import { CSS_CLASS_PREFIX } from "../constants/css";
import { withTranslation } from "react-i18next";
import { OFFER_TYPES } from "../constants/offerTypes";

const Container = styled.div`
  ${p => cssMainSelector(p.theme.tdsId)} {
    border-bottom: 1px solid ${p => p.theme.phonePicker.tabsColor};
    display: inline-flex;
    justify-content: justify-content;
    max-width: 100%;
  }
`;

const TabWrapper = styled.div`
  ${p => cssMainSelector(p.theme.tdsId)} {
    align-items: center;
    color: ${p => p.theme.phonePicker.tabsColor};
    cursor: pointer;
    flex: 1 1 auto;
    padding: 3px ${p => p.theme.spacing.lg};

    div {
      color: ${p => p.theme.phonePicker.tabsColor};
    }

    &.${CSS_CLASS_PREFIX}-selected {
      border-bottom: 3px solid ${p => p.theme.phonePicker.tabsColor};
      cursor: auto;
      font-weight: ${p => p.theme.font.weightBold};
    }
  }

  ${p => cssMainSelector(p.theme.tdsId, { mediaSizeName: "smtablet-down" })} {
    &.${CSS_CLASS_PREFIX}-tabs-count-1 {
      max-width: 100%;
    }

    &.${CSS_CLASS_PREFIX}-tabs-count-2 {
      max-width: 50%;
    }

    &.${CSS_CLASS_PREFIX}-tabs-count-3 {
      max-width: 33%;
    }
  }
`;

const TabText = styled.div`
  ${p => cssMainSelector(p.theme.tdsId)} {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
`;

class OfferTypeSwitcher extends PureComponent {
  render() {
    return <Container>{this.tabs()}</Container>;
  }

  tabs() {
    const { clientConfig, offerType } = this.props;
    const extraClass = `${CSS_CLASS_PREFIX}-tabs-count-${this.showCount()}`;
    const selectedClass = `${CSS_CLASS_PREFIX}-selected`;
    let tabs = [];

    for (const currentOfferType of Object.keys(OFFER_TYPES)) {
      if (clientConfig.widgetOptions[OFFER_TYPES[currentOfferType]].show) {
        const selected = OFFER_TYPES[currentOfferType] === offerType;

        if (selected) {
          tabs.push(
            <TabWrapper
              key={OFFER_TYPES[currentOfferType]}
              className={`${extraClass} ${selectedClass}`}
            >
              <TabText>{this.text(OFFER_TYPES[currentOfferType])}</TabText>
            </TabWrapper>
          );
        } else {
          tabs.push(
            <TabWrapper
              key={OFFER_TYPES[currentOfferType]}
              className={extraClass}
              onClick={this.onClickMethod(OFFER_TYPES[currentOfferType])}
            >
              <TabText>{this.text(OFFER_TYPES[currentOfferType])}</TabText>
            </TabWrapper>
          );
        }
      }
    }

    return tabs;
  }

  showCount() {
    const { clientConfig } = this.props;
    let count = 0;

    for (const currentOfferType of Object.keys(OFFER_TYPES)) {
      if (clientConfig.widgetOptions[OFFER_TYPES[currentOfferType]].show) {
        count += 1;
      }
    }

    return count;
  }

  text(offerType) {
    const { t } = this.props;

    if (offerType === OFFER_TYPES.phoneOffer) {
      return t("phoneOffer");
    } else if (offerType === OFFER_TYPES.proposition) {
      return t("proposition");
    } else if (offerType === OFFER_TYPES.simOnly) {
      return t("simOnly");
    }
  }

  onClickMethod(offerType) {
    const {
      onPhoneOfferClick,
      onPropositionClick,
      onSimOnlyClick
    } = this.props;

    if (offerType === OFFER_TYPES.phoneOffer) {
      return onPhoneOfferClick;
    } else if (offerType === OFFER_TYPES.proposition) {
      return onPropositionClick;
    } else if (offerType === OFFER_TYPES.simOnly) {
      return onSimOnlyClick;
    }
  }
}

OfferTypeSwitcher.propTypes = {
  clientConfig: PropTypes.object.isRequired,
  offerType: PropTypes.string.isRequired,
  onPhoneOfferClick: PropTypes.func.isRequired,
  onPropositionClick: PropTypes.func.isRequired,
  onSimOnlyClick: PropTypes.func.isRequired
};

export default withTranslation(["offerTypeSwitcher"])(OfferTypeSwitcher);
